export default __webpack_public_path__ + "static/1872-2f8b68599a9a49b508380f70969f2873.gif";